// extracted by mini-css-extract-plugin
module.exports = {"vGray9":"#c0c0c0","vGray14":"#7d85a4","post":"CalendarMonthPost_post__308R0","time":"CalendarMonthPost_time__3cfws","title":"CalendarMonthPost_title__3ifV0"};